export const initCountry = {
  id: "0",
  name: "",
  isO3166Alpha2: "",
  isO3166Alpha3: "",
  telephoneCode: null,
  smsSupported: false,
  flag: "",
}
